//      
import { getRect,               } from 'css-box-model';

export default (el             )           =>
  getRect(el.getBoundingClientRect()).center;



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/get-border-box-center-position.js